export default __webpack_public_path__ + "static/media/close.16d17dbe.svg";